import React, { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { getMatchStreamingProps } from '../data/streaming/streamingUtils';
import { filterBetsByNumberOfOdds, filtraParametriche } from '../data/utils';
import { getLabel } from '../data/labels';
import { LiveSectionContext } from '../live/common/LiveSection';
import { CustomCols } from '../live/Live';
import { adjustOddsAlignment } from '../tables-utils';
import BetsOddsHeader from './BetsOddsHeader';
import TournamentLiveMatch from './TournamentLiveMatch';

function MatchesList(props) {
    const liveSectionContext = React.useContext(LiveSectionContext);
    const customCols = React.useContext(CustomCols);

    useLayoutEffect(() => {
        adjustOddsAlignment();
    });

    const renderData = useCallback(() => {
        const data = {
            bets: null,
            matches: null,
            items: null
        };
        if (props.tournaments.length > 0) {
            data.matches = [];
            props.tournaments.forEach(t => data.matches.push(...t.events));
            data.matches.sort((m1, m2) => {
                if (liveSectionContext.sortType === 'asc') {
                    return m1.timestamp.getTime() - m2.timestamp.getTime();
                } else {
                    return m2.timestamp.getTime() - m1.timestamp.getTime();
                }
            });
        
            data.bets = data.matches[0].bets;
            data.bets = filtraParametriche(data.bets);
            data.bets = filterBetsByNumberOfOdds(data.bets, customCols);
    
            data.items = data.matches.map(function(match, index) {
                const streamingMap = getMatchStreamingProps(match);
                return (
                    <TournamentLiveMatch key={match.id} match={match} changeMatch={props.changeMatch} selected={liveSectionContext.currentMatch === match.id} streaming={streamingMap && streamingMap[match.id]} isLiveSuite={props.isLiveSuite} openWidget={index===0} />
                );
            });
        }
        return data;
    }, [liveSectionContext.currentMatch, liveSectionContext.sortType, props.changeMatch, props.isLiveSuite, props.tournaments]);

    const [data, setData] = useState(renderData());
    useMemo(() => {
        setData(renderData());
    }, [renderData]);

    if (data.items == null) {
        return null;
    }

    return (
        <div className="contenitore-table bg-bianco">
            <div className={"titolo-competizione-live bg-grigio-scuro pointer bianco bordo-tondo margine-giu-mezzo toggle-nascondi-live "+(props.collapse?'collapsed':'')} data-toggle="collapse" data-target={"#tournament-collapse-" + props.id}>
                <div className={"img-fluid img-flags margine-dx-mezzo ico-cat icoCategory" + props.categoryIcon}></div>
                <span>{props.categoryDesc}</span>
            </div>
            <div className={!props.collapse?'collapse show':'collapse'} id={"tournament-collapse-" + props.id}>
                <div className="collapse show" id="paese-calcio-1-aa">
                    <div className="tabellaQuoteIntestazione text_s1 mb-2">
                        <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                            <p>{getLabel('live_page.tournament_header.time')}</p>
                        </div>
                        <div className="tabellaQuoteCampetto">&nbsp;</div>
                        <div className="tabellaQuoteSquadre d-flex justify-content-center align-items-center"></div>
                        <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                            <BetsOddsHeader bets={data.bets} />
                        </div>
                        <div className="tabellaQuoteStatistiche"></div>
                        <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                    </div>
                    {data.items}
                </div>
            </div>
        </div>
    );
}

export default MatchesList;
